import { z } from "zod";
import { BaseEvent } from "./base";
import { Actor } from "./shared/actor";
export const Chatops_Request = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Chatops_Request"),
    event: z.object({
        command: z.string(),
        conversationId: z.string(),
        message: z.string(),
        userId: z.string(),
        ts: z.string(),
        // Who did this?
        actor: Actor.optional()
    })
});
